import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import { Vue } from 'vue-class-component';
var GridLayout = /*#__PURE__*/function (_Vue) {
  function GridLayout() {
    _classCallCheck(this, GridLayout);
    return _callSuper(this, GridLayout, arguments);
  }
  _inherits(GridLayout, _Vue);
  return _createClass(GridLayout);
}(Vue);
export { GridLayout as default };